import { useParams } from "react-router-dom";
import { Construction } from "lucide-react";

import { AppShell } from "@/components/layout/AppShell";
import { PageHeader } from "@/components/common/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

/**
 * Generic protected placeholder for approved navigation pages.
 * Shows the correct title + a clear future-phase notice. No mock records,
 * no fake functionality — exists only to verify navigation and layout.
 */
export default function ModulePage({ title, section, icon: Icon, description }) {
  return (
    <AppShell>
      <div className="space-y-8" data-testid={`module-page-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
        <PageHeader
          eyebrow={section ? `AgentHQ · ${section}` : "AgentHQ"}
          title={title}
          description={description}
          actions={<Badge variant="outline" className="border-accent/40 text-accent">Future phase</Badge>}
        />
        <Card className="border-dashed">
          <CardContent className="flex flex-col items-center gap-4 py-16 text-center">
            {Icon && (
              <div className="grid h-14 w-14 place-items-center rounded-xl bg-brand-navy text-brand-gold">
                <Icon className="h-7 w-7" />
              </div>
            )}
            <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
              <Construction className="h-4 w-4 text-accent" />
              {title} functionality will be implemented in a later approved phase
            </div>
            <p className="max-w-md text-sm text-muted-foreground">
              This placeholder exists so we can verify navigation, layout and the application shell. No business data or functionality is present yet.
            </p>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
